module.exports = __webpack_public_path__ + "img/brush-studio_cn.002a02a.jpg";